var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 38.5,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 19.5,
  y: 21.3,
  width: 6,
  height: 6.5,
  rx: 2,
  fill: "#3c4652"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 18.9,
  y: 27.7,
  width: 7.2,
  height: 1.9,
  rx: 0.9,
  fill: "#3c4652"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 21.85,
  y: 29.6,
  width: 1.3,
  height: 2.4,
  fill: "#5c6870"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 19.8,
  y: 32,
  width: 5.9,
  height: 1.1,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 21.3,
  width: 6,
  height: 6.5,
  rx: 2,
  fill: "#3c4652"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 28.4,
  y: 27.7,
  width: 7.2,
  height: 1.9,
  rx: 0.9,
  fill: "#3c4652"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 31.35,
  y: 29.6,
  width: 1.3,
  height: 2.4,
  fill: "#5c6870"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 29.3,
  y: 32,
  width: 5.9,
  height: 1.1,
  rx: 0.55,
  fill: "#5c6870"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 27.5,
  width: 27,
  height: 3,
  rx: 1.4,
  fill: "#5f7d95"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 30.5,
  width: 2.6,
  height: 8,
  fill: "#46626d"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 35.5,
  y: 30.5,
  width: 2.6,
  height: 8,
  fill: "#46626d"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 15.5,
  r: 3.2,
  fill: "#5a8fd8"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 18.7,
  width: 6.6,
  height: 10.5,
  rx: 2.8,
  fill: "#5a8fd8"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 11,
  width: 2.2,
  height: 9,
  rx: 1.1,
  fill: "#5a8fd8",
  transform: "rotate(28 10.6 19.5)"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.7,
  cy: 11.7,
  r: 1.15,
  fill: "#5a8fd8"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 5.6,
  y: 29.2,
  width: 2.4,
  height: 9.3,
  rx: 1,
  fill: "#4a77b8"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 8.8,
  y: 29.2,
  width: 2.4,
  height: 9.3,
  rx: 1,
  fill: "#4a77b8"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m8.8 36.9h2.8c0.9 0 1.3 0.4 1.3 0.85 0 0.4-0.3 0.75-0.7 0.75h-3.4z",
  fill: "#31281f"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m5.6 36.9h2.8c0.9 0 1.3 0.4 1.3 0.85 0 0.4-0.3 0.75-0.7 0.75h-3.4z",
  fill: "#31281f"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m19.6 4h8.4c1.4 0 2.6 1.2 2.6 2.6v2.8c0 1.4-1.2 2.6-2.6 2.6h-5.5l-3.6 3.2 0.5-3.3c-1.2-0.3-2.4-1.2-2.4-2.5v-2.8c0-1.4 1.2-2.6 2.6-2.6z",
  fill: "#e0704f"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 22.9,
  y: 5.7,
  width: 1.7,
  height: 4.6,
  rx: 0.85,
  fill: "#ffffff"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 21.45,
  y: 7.15,
  width: 4.6,
  height: 1.7,
  rx: 0.85,
  fill: "#ffffff"
});

function SvgInMeetingRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInMeetingRequest);
export default __webpack_public_path__ + "static/media/in-meeting-request.b8c9edc73fe8cec114d6e0fa139e5ec5.svg";
export { ForwardRef as ReactComponent };